import React from "react";
import {
  Divider,
  Button,
  Grid,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import RichTextEditor from "react-rte";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import { formatDate } from "../../../common/formatDate";

export const NotesProjects = ({ id, type }: any) => {
  const { authAxios } = useFetchContext();

  const [open, setOpen] = React.useState(false);
  const [isFirstClick, setIsFirstClick] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [notes, setNotes] = React.useState<any[]>([]);
  const [err, setErr] = React.useState("");

  const handleToggleDialog = () => setOpen(!open);

  const getProjectNotes = async (): Promise<void> => {
    try {
      setIsLoading(true);
      const response = await authAxios.get(urls.reportWriterAgenda.report_project_Notes(id));
      setNotes(response.data || []);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setErr("Error fetching notes");
      setIsLoading(false);
    }
  };

  const handleInitialLoad = async () => {
    setIsFirstClick(false);
    await getProjectNotes();
  };

  if (isLoading) {
    return (
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      </Grid>
    );
  }

  if (isFirstClick) {
    return (
      <Button color="inherit" onClick={handleInitialLoad} fullWidth>
        Click Notes
      </Button>
    );
  }

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleToggleDialog}
        fullWidth
      >
        Notes ({notes.length})
      </Button>

      <Dialog open={open} onClose={handleToggleDialog} fullWidth maxWidth="md">
        <DialogTitle>Attached Notes</DialogTitle>
        <DialogContent dividers>
          <Divider style={{ marginBottom: 16 }} />
          {err && <Typography color="error">{err}</Typography>}
          {notes.length === 0 ? (
            <Typography variant="body2">No notes yet.</Typography>
          ) : (
            notes.map((note, index) => (
              <Grid container key={index} spacing={2}>
                <Grid item xs={5}>
                  <Typography variant="body1">{note.subject}</Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography variant="body2">From: {note.username}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="body2">At: {formatDate(note.datetime)}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <RichTextEditor
                    value={RichTextEditor.createValueFromString(note.text || "", "markdown")}
                    readOnly
                  />
                </Grid>
              </Grid>
            ))
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleToggleDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
